module.exports = __webpack_public_path__ + "static/img/erweima.931e289e.jpg";